import styled from 'styled-components';

export const IconStyled = styled.button`
  padding: 0 0.2em;
  background: none;
  border: none;
`;
